import React from 'react';
import { IconProps } from '.';

const SvgPercentBadge = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M13.64 2.831a2.2 2.2 0 0 0-3.28 0l-.77.861a2.2 2.2 0 0 1-1.76.73l-1.154-.064a2.2 2.2 0 0 0-2.319 2.318l.064 1.153a2.2 2.2 0 0 1-.729 1.761l-.861.77a2.2 2.2 0 0 0 0 3.28l.861.77a2.2 2.2 0 0 1 .73 1.76l-.065 1.154a2.2 2.2 0 0 0 2.319 2.318l1.153-.063a2.2 2.2 0 0 1 1.761.729l.77.861a2.2 2.2 0 0 0 3.28 0l.77-.861a2.2 2.2 0 0 1 1.76-.73l1.154.064a2.2 2.2 0 0 0 2.318-2.317l-.063-1.154a2.2 2.2 0 0 1 .729-1.761l.861-.77a2.2 2.2 0 0 0 0-3.28l-.861-.77a2.2 2.2 0 0 1-.73-1.76l.064-1.154a2.2 2.2 0 0 0-2.318-2.319l-1.154.064a2.2 2.2 0 0 1-1.76-.729l-.77-.861Zm2.19 6.4a.75.75 0 0 0-1.06-1.06l-6.6 6.6a.75.75 0 0 0 1.06 1.06l6.6-6.6ZM9.25 10.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm7.05 4a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgPercentBadge;
